import PropTypes from 'prop-types';
import address from './address';
import grade from './grade';
import orgUnit from './orgUnit';
import { ActivityPropType } from './activity';
import timeSlot from './timeSlot';
import ragStatus from './ragStatus';
import timeSlotPackage from './timeSlotsPackage';

const treatmentInstance = PropTypes.shape({
  assignGuid: PropTypes.number.isRequired,
  activities: PropTypes.arrayOf(ActivityPropType),
  activitiesTotalDuration: PropTypes.number,
  additionalCliniciansCount: PropTypes.number,
  address,
  cardType: PropTypes.string,
  copiesCount: PropTypes.number,
  effectiveTimeSlots: PropTypes.arrayOf(timeSlot),
  highestGrade: grade,
  highestGradeEquivalence: PropTypes.number,
  isFirstChild: PropTypes.bool,
  isLastChild: PropTypes.bool,
  isMasterAssigned: PropTypes.bool,
  isSingleTimeSlot: PropTypes.bool,
  isTwilightTreatment: PropTypes.bool,
  isSpecificTime: PropTypes.bool,
  masterId: PropTypes.number,
  occurrence: PropTypes.string,
  orgUnits: PropTypes.arrayOf(orgUnit),
  patientFullName: PropTypes.string,
  ragStatus,
  selectedTimeSlots: PropTypes.objectOf(PropTypes.objectOf(PropTypes.bool)),
  status: PropTypes.string,
  timeSlotPackage,
  timeSlots: PropTypes.arrayOf(timeSlot),
  treatmentId: PropTypes.number,
  treatmentInstanceId: PropTypes.number,
  wasUnassignedBySynchronization: PropTypes.bool,
  hasVarianceFactorChanged: PropTypes.bool,
});

export default treatmentInstance;
